// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import escapeAttribute from '../escapeAttribute';
import Locale from '../Locale';

export const COLUMN_SELECTION = {
    cls: 'select',
    headerCls: 'select',
    hideDisabled: false,
    headerRenderer() {
        const locale = Locale.getSection('admin.components.lists');
        return `<input type="checkbox" class="checkbox" name="listGlobalCheckbox" aria-label="${locale.lmsg('selectAllAriaLabel')}" />`;
    },
    renderer(item, isDisabled) {
        const locale = Locale.getSection('admin.components.lists');
        if (!isDisabled) {
            return `<input type="checkbox" class="checkbox" name="listCheckbox[]" value="${escapeAttribute(item.id)}" aria-label="${locale.lmsg('selectItemAriaLabel')}"/>`;
        }

        return (
            '<div>' +
                '<span class="checkbox-disabled-wrapper"></span>' +
                `<input style="z-index: 1;" disabled="disabled" type="checkbox" class="checkbox" aria-label="${locale.lmsg('selectItemAriaLabel')}"/>` +
            '</div>'
        );
    },
};

export const COLUMN_ACTIONS = {
    header: '',
    cls: 'min',
    sortable: false,
    renderer(item) {
        if (!item.actions || !item.actions.length) {
            return '';
        }
        const locale = Locale.getSection('admin.components.lists');
        const rowId = item.id ? escapeAttribute(item.id) : '';
        return (
            '<span class="btn-group list-menu">' +
                `<button type="button" class="btn btn-list-menu dropdown-toggle" data-row-id="${rowId}" aria-label="${locale.lmsg('actionsAriaLabel')}">` +
                    '<i class="icon">' +
                        `<img src="${require('icons/16/plesk/menu.png')}" alt="">` +
                    '</i> ' +
                    '<em class="caret"></em>' +
                '</button>' +
            '</span>'
        );
    },
};

export const ITEMS_UNLIMITED = 100000;
